import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SuccessPopup from 'Common/Components/SuccessPopup';
import {
  selectStatus, selectMessage, selectError
} from 'store/Settings/twoFactorSelectors';
import { clearTwoFactorMessage } from 'store/Settings/twoFactorActions';

const TwoFactorSuccessNotice = () => {
  const dispatch = useDispatch();

  const props = useSelector((state) => ({
    status: selectStatus(state),
    message: selectMessage(state),
    error: selectError(state)
  }));

  const show = Boolean(props.message) && !props.error && props.status !== 'requested';

  if (!show) return null;

  return (
    <SuccessPopup message={ props.message } close={ () => dispatch(clearTwoFactorMessage()) } />
  );
};

export default TwoFactorSuccessNotice;
